// Shared-component strings, namespaced as 'components.<componentName>.<key>'.
export default {
  'components.cleanTextContextMenu.copy': '참조 없이 텍스트 복사',
  'components.cleanTextContextMenu.copied': '텍스트를 복사했습니다',
  'components.cleanTextContextMenu.failed': '텍스트를 복사하지 못했습니다. 다시 시도해 주세요.',
  'components.addToMattersPopover.selectMattersLabel': '매터 선택:',
  'components.addToMattersPopover.searchPlaceholder': '매터 검색...',
  'components.addToMattersPopover.updateSuccess': '매터가 성공적으로 업데이트되었습니다',
  'components.addToMattersPopover.updateError': '매터 업데이트에 실패했습니다',
  'components.billingRequiredOverlay.defaultMessage':
    '이 작업을 계속하려면 조직의 청구 문제를 먼저 해결해야 합니다. 조직 관리자에게 문의하세요.',
  'components.billingRequiredOverlay.title': '결제 정보 필요',
  'components.billingRequiredOverlay.manageBillingButton': '결제 관리',
  'components.chat.jsonResponseTitle': 'JSON 응답',
  'components.chat.dataOpenedInNewTab': '새 탭에서 데이터가 열렸습니다',
  'components.chat.textResponseTitle': '텍스트 응답',
  'components.chat.contentOpenedInNewTab': '새 탭에서 콘텐츠가 열렸습니다',
  'components.chat.fileOpenedInNewTab': '새 탭에서 파일이 열렸습니다',
  'components.chat.failedToOpenNewTab': '새 탭을 여는 데 실패했습니다',
  'components.chat.failedToFetchUrl': 'URL을 가져오지 못했습니다: {message}',
  'components.chat.referenceDocumentFallback': '참조 문서',
  'components.chat.sourcesCount': '출처 ({count})',
  'components.chat.referencesCount': '참조 {count}건',
  'components.chat.htmlContentTitle': 'HTML 콘텐츠',
  'components.chat.showMoreLines': '더 보기 ({count}줄)',
  'components.chatWidget.waitingMessage.justAMoment': '잠시만 기다려 주세요...',
  'components.chatWidget.waitingMessage.fetchingThatForYou': '요청하신 내용을 가져오는 중입니다...',
  'components.chatWidget.waitingMessage.hangTight': '잠시만요, 처리하고 있습니다...',
  'components.chatWidget.waitingMessage.letMeCheck': '확인해 볼게요...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond': '잠시만 기다리시면 됩니다...',
  'components.chatWidget.closeChatAriaLabel': '채팅 닫기',
  'components.chatWidget.openChatAriaLabel': '채팅 열기',
  'components.chatWidget.processingTooltip': '처리가 완료되면 채팅을 이용할 수 있습니다',
  'components.chatWidget.messageCopied': '메시지가 복사되었습니다!',
  'components.chatWidget.copyMessageFailed': '메시지 복사에 실패했습니다',
  'components.chatWidget.header.title': '채팅',
  'components.chatWidget.emptyState.title': '무엇을 도와드릴까요?',
  'components.chatWidget.inputPlaceholder': '메시지를 입력하세요...',
  'components.chatWidget.showMoreLines': '더 보기 ({count}줄)',
  'components.chatWidget.invalidFileUrl': '잘못되었거나 누락된 파일 URL입니다',
  'components.chatWidget.fileDownloadedSuccessfully': '파일이 성공적으로 다운로드되었습니다',
  'components.chatWidget.fileDownloadFailed': '파일 다운로드에 실패했습니다: {message}',
  'components.chatWidget.unnamedFile': '파일',
  'components.chatWidget.attachmentImageAlt': '첨부 파일',
  'components.checklistCard.heading': '체크리스트',
  'components.downloadLoadingMask.downloading': '다운로드 중...',
  'components.emlViewer.fromLabel': '보낸 사람:',
  'components.emlViewer.toLabel': '받는 사람:',
  'components.emlViewer.ccLabel': '참조:',
  'components.emlViewer.dateLabel': '날짜:',
  'components.emlViewer.attachmentsLabel': '첨부 파일:',
  'components.filesSidePanel.favoritesButton': '즐겨찾기',
  'components.filesSidePanel.historyButton': '기록',
  'components.filesSidePanel.untitledPlaceholder': '(제목 없음)',
  'components.filesSidePanel.membersPopoverTitle': '멤버',
  'components.filesSidePanel.ownerTag': '소유자',
  'components.filesSidePanel.modifyGroupTooltip': '그룹 수정',
  'components.filesSidePanel.privateGroupWarningTooltip': '낮은 보안: 내 그룹에 공개됩니다.',
  'components.filesSidePanel.firmWideWarningTooltip': '매우 낮은 보안: 회사 전체에 공개됩니다.',
  'components.filesSidePanel.publicWarningTooltip': '매우 낮은 보안: 모든 사용자에게 공개됩니다.',
  'components.filesSidePanel.sortByDateLabel': '날짜순 정렬 (최신순)',
  'components.filesSidePanel.sortAlphabeticallyLabel': '알파벳순 정렬 (A-Z)',
  'components.gettingStartedTour.insiderHero.openLinkLabel': 'A&GEL Insider 열기',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle':
    '새로운 도구를 익히는 데는 시간이 걸립니다',
  'components.gettingStartedTour.insiderHero.basicsCard.copy':
    '처음부터 필요한 모든 것을 제공합니다.',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': '기본부터 시작하기',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    '한 단계 더 나아가고 싶다면 고급 기능을 살펴보세요.',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': '더 알아보기',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy':
    '최근 출시된 기능과 업데이트 소식입니다.',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': '새로운 소식',
  'components.gettingStartedTour.insiderHero.marinaAlt': '마리나 스카이라인',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': '추천 아티클',
  'components.gettingStartedTour.insiderHero.filesUpload.title': '파일 업로드',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    '첨부 파일을 포함한 이메일 파일 전체를 A&GEL에 업로드하여 다른 문서와 동일하게 활용할 수 있습니다.',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': '더 보기',
  'components.gettingStartedTour.allCompleted.title': 'A&GEL 전체 투어를 완료했습니다!',
  'components.gettingStartedTour.allCompleted.redoButton': '투어 다시 보기',
  'components.gettingStartedTour.heading': '시작하기',
  'components.gettingStartedTour.tourStyles.stepIndicator': '{total}단계 중 {current}단계',
  'components.gettingStartedTour.tourStyles.nextDefault': '다음 →',
  'components.gettingStartedTour.chatTour.step1.title':
    '샘플 NDA 문서를 불러왔습니다. 확인하려면 컨텍스트를 클릭하세요.',
  'components.gettingStartedTour.chatTour.step1.text':
    '여기에서 A&GEL이 답변 시 참조하는 문서를 관리할 수 있습니다.',
  'components.gettingStartedTour.chatTour.step2.title': '불러온 문서입니다.',
  'components.gettingStartedTour.chatTour.step2.text':
    '파일을 업로드하거나 보관함(Vault)에서 선택할 수 있습니다. 준비되면 패널을 닫으세요.',
  'components.gettingStartedTour.chatTour.step2.nextLabel': '닫고 계속하기 →',
  'components.gettingStartedTour.chatTour.step3.title':
    '질문을 준비해 두었습니다. 전송을 클릭하여 NDA에 대해 질문해 보세요.',
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay':
    '이 계약서의 비밀유지 의무는 무엇인가요?',
  'components.gettingStartedTour.chatTour.step4.title':
    '좋은 답변이네요! 이제 참조 번호(예: [1])를 클릭하여 원본 문서를 확인해 보세요.',
  'components.gettingStartedTour.chatTour.step4.text':
    '참조는 AI가 사용한 문서의 정확한 부분으로 연결됩니다.',
  'components.gettingStartedTour.chatTour.completeModal.title': '잘하셨습니다!',
  'components.gettingStartedTour.chatTour.completeModal.description':
    '채팅에서 첫 질문을 하고 출처가 표시된 답변을 받았습니다.',
  'components.gettingStartedTour.tourComplete.progressText': '5개 기능 중 {completedCount}개 완료',
  'components.gettingStartedTour.tourComplete.completeButton': '완료',
  'components.gettingStartedTour.tourComplete.continueButton': '{title}(으)로 계속하기 →',
  'components.gettingStartedTour.playbookTour.completeModal.title': '수고하셨습니다!',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    'Workstudio에서 수정 사항을 적용했습니다.',
  'components.gettingStartedTour.playbookTour.step1.title':
    '수정이 필요한 샘플 공급업체 계약서를 불러왔습니다.',
  'components.gettingStartedTour.playbookTour.step1.text':
    '귀하는 공급업체(Pand.ai)로서 고객에게 더 유리한 조건을 요청하는 입장입니다.',
  'components.gettingStartedTour.playbookTour.step1.openingLabel': '여는 중…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': '샘플 열기 →',
  'components.gettingStartedTour.playbookTour.step2.title': '3건의 수정 요청을 작성했습니다:',
  'components.gettingStartedTour.playbookTour.step2.item1': '• 지식재산권 공동 소유 (제17조)',
  'components.gettingStartedTour.playbookTour.step2.item2': '• 14일 시정 기간 추가 (제8조)',
  'components.gettingStartedTour.playbookTour.step2.item3': '• 경업금지 조항 범위 축소 (제27조)',
  'components.gettingStartedTour.playbookTour.step2.text':
    '다단계 모드는 각 항목을 병렬로 처리하여 더 빠른 결과를 제공합니다.',
  'components.gettingStartedTour.playbookTour.step3.title':
    '전송을 클릭하여 수정 사항을 생성하세요.',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL이 변경 내용을 추적하여 표시하며, 이를 수락, 거부하거나 다운로드할 수 있습니다.',
  'components.gettingStartedTour.playbookTour.step4.title':
    'A&GEL이 입력하신 프롬프트를 바탕으로 작성한 수정 사항입니다.',
  'components.gettingStartedTour.playbookTour.step4.text':
    '각 카드에는 원문과 제안된 변경 사항이 표시됩니다.',
  'components.gettingStartedTour.playbookTour.step5.title':
    '이 수정 사항을 검토하고 수락하거나 거부하세요.',
  'components.gettingStartedTour.playbookTour.step5.text':
    '나머지 항목도 나중에 동일한 방식으로 처리할 수 있습니다.',
  'components.gettingStartedTour.reviewTour.completeModal.title': '훌륭합니다!',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    '질문 목록을 생성하고 이를 사용해 문서를 검토했습니다.',
  'components.gettingStartedTour.reviewTour.step1.title':
    'Review는 질문 목록을 사용해 여러 문서에서 질문에 대한 답을 찾아줍니다.',
  'components.gettingStartedTour.reviewTour.step1.text':
    '직접 만들거나 기존 목록을 사용할 수 있습니다.',
  'components.gettingStartedTour.reviewTour.step2.title':
    '카테고리별로 미리 만들어진 질문 목록을 둘러보세요.',
  'components.gettingStartedTour.reviewTour.step3.title':
    '직접 만들어 볼까요. 여기를 클릭하여 새 질문 목록을 시작하세요.',
  'components.gettingStartedTour.reviewTour.step4.title': '목록을 정리할 카테고리를 선택하세요.',
  'components.gettingStartedTour.reviewTour.step5.title':
    '샘플 질문이 편집 가능한 행으로 목록에 추가되었습니다.',
  'components.gettingStartedTour.reviewTour.step6.title':
    '질문이 편집 가능한 행으로 여기에 표시됩니다. 언제든 삭제하거나 섹션을 추가해 그룹화할 수 있습니다.',
  'components.gettingStartedTour.reviewTour.step7.title':
    '이 목록의 용도를 설명하여 필요에 맞게 구성하세요.',
  'components.gettingStartedTour.reviewTour.step8.title':
    'AI의 답변 방식(어조, 형식, 상세 수준)을 조정하세요.',
  'components.gettingStartedTour.reviewTour.step9.title': '목록을 저장하여 문서에 사용하세요.',
  'components.gettingStartedTour.reviewTour.step10.title':
    '직접 사용해 볼 수 있도록 샘플 문서를 불러왔습니다.',
  'components.gettingStartedTour.reviewTour.step10.text':
    '질문 목록을 이 문서들에 바로 실행할 수 있습니다.',
  'components.gettingStartedTour.reviewTour.step11.title':
    '제출을 클릭하여 모든 문서에 대해 검토를 실행하세요.',
  'components.gettingStartedTour.reviewTour.step12.title':
    '각 행은 질문, 각 열은 문서를 나타내며 답변은 자동으로 추출됩니다.',
  'components.gettingStartedTour.reviewTour.step13.title':
    '답변을 클릭하면 정확한 출처를 확인할 수 있습니다.',
  'components.gettingStartedTour.reviewTour.step14.title':
    '참조 번호를 클릭하면 원본 문서의 정확한 위치로 이동합니다.',
  'components.gettingStartedTour.reviewTour.step15.title':
    '이것으로 Review 전체 흐름을 마쳤습니다 — 출처는 언제나 클릭 한 번이면 확인할 수 있습니다. 완료되었습니다!',
  'components.gettingStartedTour.reviewTour.step15.nextLabel': '완료',
  'components.gettingStartedTour.scribeTour.completeModal.title': '수고하셨습니다!',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    'Scribe로 오디오를 전사했습니다.',
  'components.gettingStartedTour.scribeTour.step1.title':
    '전사 결과를 어떤 용도로 사용할지 선택하세요.',
  'components.gettingStartedTour.scribeTour.step1.text':
    '이는 A&GEL이 출력 형식을 맞추는 데 도움이 됩니다. "회의록"이 이미 선택되어 있습니다.',
  'components.gettingStartedTour.scribeTour.step2.title': '언어가 "자동 감지"로 설정되어 있습니다.',
  'components.gettingStartedTour.scribeTour.step2.text':
    '실시간 번역을 활성화하면 번역을 실시간으로 확인할 수도 있습니다.',
  'components.gettingStartedTour.scribeTour.step3.title':
    '녹음 버튼을 클릭하거나 기존 오디오 파일을 업로드하세요.',
  'components.gettingStartedTour.scribeTour.step4.title':
    '전사 내용을 저장할 준비가 되면 정지를 클릭하세요.',
  'components.gettingStartedTour.scribeTour.step5.title':
    '전사 파일의 이름을 입력한 후 저장을 클릭하세요.',
  'components.gettingStartedTour.scribeTour.step6.title':
    '전사 텍스트의 줄을 클릭하면 해당 지점부터 오디오가 재생됩니다.',
  'components.gettingStartedTour.scribeTour.step7.title': '편집을 클릭하여 전사 내용을 수정하세요.',
  'components.gettingStartedTour.scribeTour.step7.text': '변경한 내용은 금색으로 표시됩니다.',
  'components.gettingStartedTour.scribeTour.step8.title': '저장을 클릭하여 변경 사항을 유지하세요.',
  'components.gettingStartedTour.scribeTour.step8.text':
    '저장 전까지 수정한 내용은 금색으로 표시됩니다.',
  'components.gettingStartedTour.searchTour.completeModal.title': '잘하셨습니다!',
  'components.gettingStartedTour.searchTour.completeModal.description':
    '문서 전체를 검색하여 관련 조항을 찾았습니다.',
  'components.gettingStartedTour.searchTour.step1.title': '검색어를 미리 준비해 두었습니다.',
  'components.gettingStartedTour.searchTour.step1.text':
    '검색을 클릭하거나 Enter 키를 눌러 일치하는 조항을 찾아보세요.',
  'components.gettingStartedTour.searchTour.step2.title':
    'NDA에서 찾은 일치 항목입니다. 문서를 클릭하면 그 안의 모든 일치 항목을 볼 수 있습니다.',
  'components.gettingStartedTour.searchTour.step3.title':
    '일치 항목을 클릭하면 문서 내 해당 섹션으로 이동합니다.',
  'components.gettingStartedTour.searchTour.step3.text':
    '왼쪽에는 일치하는 발췌 내용이 표시되고, 오른쪽에는 키워드가 강조 표시된 전체 문서가 표시됩니다.',
  'components.gettingStartedTour.tourButton.label': '투어',
  'components.gettingStartedTour.tourCompleteModal.features.chat': '채팅에서 질문하기',
  'components.gettingStartedTour.tourCompleteModal.features.search': '문서 전체 검색하기',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': 'Scribe로 전사하기',
  'components.gettingStartedTour.tourCompleteModal.features.review': 'Review로 분석하기',
  'components.gettingStartedTour.tourCompleteModal.features.playbook':
    'Workstudio에서 수정 사항 적용하기',
  'components.gettingStartedTour.tourCompleteModal.title': '모든 준비가 완료되었습니다!',
  'components.gettingStartedTour.tourCompleteModal.subtitle':
    'A&GEL 투어를 완료하고 다음 사용 방법을 배웠습니다:',
  'components.gettingStartedTour.tourCompleteModal.progressText': '5개 기능 중 5개 완료',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': 'A&GEL 시작하기 →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix':
    '도움이 필요하신가요? 다음을 방문하세요: ',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': '사용자 가이드',
  'components.lLMMetrics.status.fast': '빠름',
  'components.lLMMetrics.status.slow': '느림',
  'components.lLMMetrics.status.busy': '사용 중',
  'components.lLMMetrics.status.pending': '대기 중',
  'components.lLMMetrics.status.loading': '로딩 중',
  'components.lLMMetrics.metricBox.defaultChartLabel': '값',
  'components.management.passwordModal.usernameColumn': '사용자 이름',
  'components.management.passwordModal.passwordColumn': '비밀번호',
  'components.management.passwordModal.createHeader':
    '다음 자격 증명으로 사용자를 성공적으로 생성했습니다:',
  'components.management.passwordModal.emailChangeHeader':
    '사용자 이메일을 성공적으로 변경했습니다. 새 자격 증명은 다음과 같습니다:',
  'components.management.passwordModal.changePasswordNotice':
    '*사용자는 최초 로그인 후 비밀번호를 변경해야 합니다',
  'components.menuPanel.untitledItem': '(제목 없음)',
  'components.menuPanel.renameFailed': '이름 변경에 실패했습니다',
  'components.menuPanel.deleteConfirm.title': '기록 항목 삭제',
  'components.menuPanel.deleteConfirm.content':
    '이 기록 항목을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
  'components.menuPanel.deleteConfirm.createdLabel': '생성일:',
  'components.menuPanel.deleteSuccess': '기록 항목이 삭제되었습니다',
  'components.menuPanel.deleteFailed': '기록 항목 삭제에 실패했습니다',
  'components.menuPanel.searchHistoryButton': '기록 검색',
  'components.menuPanel.historyLabel': '기록',
  'components.menuPanel.showAllButton': '전체 보기',
  'components.menuPanel.showFavoritesButton': '즐겨찾기 보기',
  'components.menuPanel.endOfListMessage': '- 목록의 끝입니다 -',
  'components.message.enhanceGpt.modalTitle': 'GPT 응답 개선',
  'components.message.enhanceGpt.successMessage': '새 응답이 기록되었습니다',
  'components.message.enhanceGpt.questionLabel': '질문: {question}',
  'components.message.enhanceGpt.answerLabel': '답변',
  'components.message.postback.clickedLabel': '클릭됨:',
  'components.message.postback.chatbotButtonFallback': '챗봇 버튼',
  'components.message.locationLabel': '위치',
  'components.message.stickerLabel': '스티커',
  'components.message.audiosLabel': '오디오',
  'components.message.imagesLabel': '이미지',
  'components.message.videosLabel': '동영상',
  'components.msgViewer.fromLabel': '보낸 사람:',
  'components.msgViewer.toLabel': '받는 사람:',
  'components.msgViewer.attachmentsLabel': '첨부 파일:',
  'components.pdfViewerWithHighlight.renderError': 'PDF를 렌더링하지 못했습니다',
  'components.promptSelector.copySuccess': '프롬프트가 복사되었습니다!',
  'components.promptSelector.copyError': '프롬프트 복사에 실패했습니다',
  'components.promptSelector.noResultsFiltered': '필터에 맞는 프롬프트를 찾을 수 없습니다',
  'components.promptSelector.startTyping': '프롬프트를 검색하려면 입력을 시작하세요',
  'components.promptSelector.promptLoaded': '프롬프트가 채팅 입력창에 불러와졌습니다!',
  'components.promptSelector.untitledPrompt': '제목 없는 프롬프트',
  'components.promptSelector.actionPlaceholder': '작업',
  'components.promptSelector.actionOption.summarise': '요약',
  'components.promptSelector.actionOption.review': '검토',
  'components.promptSelector.actionOption.amend': '수정',
  'components.promptSelector.actionOption.draft': '초안 작성',
  'components.promptSelector.actionOption.redFlagging': '레드플래그 표시',
  'components.promptSelector.audiencePlaceholder': '대상',
  'components.promptSelector.audienceOption.personal': '개인',
  'components.promptSelector.audienceOption.group': '그룹',
  'components.promptSelector.audienceOption.public': '공개',
  'components.promptSelector.selectPromptHint': '프롬프트를 선택하면 입력창에 불러옵니다',
  'components.promptSelector.usePromptButton': '프롬프트 사용',
  'components.promptSelector.authorLabel': '작성자',
  'components.promptSelector.promptLabel': '프롬프트',
  'components.promptSelector.tagsLabel': '태그',
  'components.promptSelector.documentsAttached': '문서 {count}개가 첨부됩니다',
  'components.questionListSelection.untitledQuestionList': '(제목 없음)',
  'components.questionListSelection.questionCount': '질문 {count}개',
  'components.questionListSelection.accessPublicTag': '공개',
  'components.questionListSelection.accessFirmTag': '펌',
  'components.questionListSelection.accessGroupTag': '비공개 그룹',
  'components.questionListSelection.viewLess': '간략히 보기',
  'components.questionListSelection.viewAll': '전체 보기',
  'components.questionListSelection.whatsNewButton': '새로운 기능',
  'components.questionListSelection.tourTooltip': '둘러보기 시작',
  'components.questionListSelection.tourButton': '둘러보기',
  'components.questionListSelection.sortMostPopular': '정렬: 인기순',
  'components.questionListSelection.sortNameAsc': '정렬: 이름 오름차순(A-Z)',
  'components.questionListSelection.sortNameDesc': '정렬: 이름 내림차순(Z-A)',
  'components.questionListSelection.filterByAudiencePlaceholder': '대상별 필터',
  'components.questionListSelection.audienceOptionPersonal': '개인',
  'components.questionListSelection.audienceOptionPublic': '공개',
  'components.questionListSelection.filterByAuthorPlaceholder': '작성자별 필터',
  'components.reference.unknownAuthor': '알 수 없음',
  'components.reference.timeAgo.justNow': '방금 전',
  'components.reference.timeAgo.minutesAgo': '{count, plural, one {#분 전} other {#분 전}}',
  'components.reference.timeAgo.hoursAgo': '{count, plural, one {#시간 전} other {#시간 전}}',
  'components.reference.timeAgo.daysAgo': '{count, plural, one {#일 전} other {#일 전}}',
  'components.reference.openCellDetails': '셀 상세정보 열기',
  'components.reference.answerLabel': '답변: ',
  'components.reference.explanationLabel': '설명',
  'components.reference.verifiedLabel': '확인됨',
  'components.reference.verifyLabel': '확인',
  'components.reference.pleaseEnterComment': '댓글을 입력해 주세요',
  'components.reference.matrixIdRequired':
    'Matrix ID가 필요합니다. Reference 컴포넌트에 matrixId prop이 전달되었는지 확인해 주세요.',
  'components.reference.commentAddedSuccess': '댓글이 등록되었습니다',
  'components.reference.failedToAddComment': '댓글 등록에 실패했습니다',
  'components.reference.commentUpdatedSuccess': '댓글이 수정되었습니다',
  'components.reference.updateOwnCommentsOnly': '본인이 작성한 댓글만 수정할 수 있습니다',
  'components.reference.failedToUpdateComment': '댓글 수정에 실패했습니다',
  'components.reference.commentDeletedSuccess': '댓글이 삭제되었습니다',
  'components.reference.deleteOwnCommentsOnly': '본인이 작성한 댓글만 삭제할 수 있습니다',
  'components.reference.failedToDeleteComment': '댓글 삭제에 실패했습니다',
  'components.reference.deleteComment.title': '댓글 삭제',
  'components.reference.deleteComment.description': '이 댓글을 삭제하시겠습니까?',
  'components.reference.addCommentPlaceholder': '댓글을 입력하세요...',
  'components.reference.cellsSelected':
    '{count, plural, one {#개 셀이 선택되었습니다.} other {#개 셀이 선택되었습니다.}}',
  'components.reference.selectCellAriaLabel': '셀 선택',
  'components.reference.selectQuestionRowAriaLabel': '질문 행 선택',
  'components.reference.selectDocumentColumnAriaLabel': '문서 열 선택',
  'components.reference.selectDocumentRowAriaLabel': '문서 행 선택',
  'components.reference.selectQuestionColumnAriaLabel': '질문 열 선택',
  'components.reference.documentsHeader': '문서',
  'components.reference.addRow': '행 추가',
  'components.reference.addColumn': '열 추가',
  'components.reference.inverse': '반전',
  'components.reference.showAllColumns': '모든 열 표시',
  'components.reference.showAllRows': '모든 행 표시',
  'components.reference.resetView': '보기 초기화',
  'components.reference.summaryView': '요약 보기',
  'components.reference.detailedView': '상세 보기',
  'components.reference.exitSelectMode': '종료',
  'components.reference.chatWithSelectedOutput': '선택한 결과로 채팅하기',
  'components.reference.selectCells': '셀 선택',
  'components.referencePopover.fileLinkUnavailable': '파일 링크를 사용할 수 없습니다',
  'components.referencePopover.failedToOpenNewTab': '새 탭 열기에 실패했습니다',
  'components.referencePopover.failedToOpenFile': '파일 열기에 실패했습니다',
  'components.referencePopover.openInNewTab': '새 탭에서 문서 열기 ↗',
  'components.rightContent.organisationSwitcher.switching': '조직 전환 중...',
  'components.rightContent.organisationSwitcher.switchSuccess': '조직이 성공적으로 전환되었습니다',
  'components.rightContent.organisationSwitcher.switchNoToken':
    '조직 전환 시 새 토큰을 받지 못했습니다',
  'components.rightContent.organisationSwitcher.switchError': '조직 전환에 실패했습니다',
  'components.rightContent.organisationSwitcher.unknownOrg': '알 수 없는 조직',
  'components.rightContent.organisationSwitcher.defaultLabel': '조직',
  'components.rightContent.organisationSwitcher.tooltipFallback': '조직 전환',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.rightContent.angelTeamsButton.label': '문의하기',
  'components.rightContent.reportBug.label': '버그 신고',
  'components.rightContent.reportBug.modalDescription':
    '아래 양식을 작성하여 발견하신 내용을 알려주세요.',
  'components.rightContent.reportBug.contactSectionTitle': '연락처',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': '버그 설명',
  'components.rightContent.reportBug.environmentSectionTitle': '환경',
  'components.rightContent.reportBug.namePlaceholder': '이름을 입력하세요',
  'components.rightContent.reportBug.nameRequired': '이름을 입력해 주세요',
  'components.rightContent.reportBug.emailLabel': '이메일',
  'components.rightContent.reportBug.emailPlaceholder': '이메일을 입력하세요',
  'components.rightContent.reportBug.emailRequired': '이메일을 입력해 주세요',
  'components.rightContent.reportBug.emailInvalid': '유효한 이메일을 입력해 주세요',
  'components.rightContent.reportBug.locationLabel': '버그를 어디에서 발견하셨나요?',
  'components.rightContent.reportBug.locationPlaceholder': '기능 선택',
  'components.rightContent.reportBug.locationRequired': '버그가 발견된 위치를 지정해 주세요',
  'components.rightContent.reportBug.descriptionLabel': '문제를 설명해 주세요',
  'components.rightContent.reportBug.descriptionRequired': '문제를 설명해 주세요',
  'components.rightContent.reportBug.filesLabel': '스크린샷 또는 녹화 영상',
  'components.rightContent.reportBug.uploadText': '클릭하거나 드래그하여 업로드',
  'components.rightContent.reportBug.fileSizeKb': '{size}KB',
  'components.rightContent.reportBug.removeFile': '{fileName} 제거',
  'components.rightContent.reportBug.deviceLabel': '기기',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': '사용 중인 기기를 입력해 주세요',
  'components.rightContent.reportBug.osLabel': '운영체제 및 버전',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': '운영체제를 입력해 주세요',
  'components.rightContent.reportBug.browserLabel': '브라우저',
  'components.rightContent.reportBug.browserPlaceholder': '브라우저 선택',
  'components.rightContent.reportBug.browserRequired': '사용 중인 브라우저를 입력해 주세요',
  'components.rightContent.reportBug.submitSuccess': '버그 신고가 성공적으로 제출되었습니다!',
  'components.rightContent.reportBug.submitError':
    '버그 신고 제출에 실패했습니다. 다시 시도해 주세요.',
  'components.rightContent.reportBug.invalidFileType':
    '이미지 또는 동영상 파일만 업로드할 수 있습니다!',
  'components.rightContent.reportBug.fileUploadSuccess':
    '파일 "{fileName}"이(가) 성공적으로 업로드되었습니다!',
  'components.rightContent.reportBug.fileUploadError': '파일 업로드에 실패했습니다',
  'components.rightContent.reportBug.page.home': '홈',
  'components.rightContent.reportBug.page.chat': '채팅',
  'components.rightContent.reportBug.page.composer': '작성기',
  'components.rightContent.reportBug.page.review': '검토',
  'components.rightContent.reportBug.page.reference': '참조',
  'components.rightContent.reportBug.page.files': '파일',
  'components.rightContent.reportBug.page.userProfile': '사용자 프로필',
  'components.rightContent.reportBug.page.other': '기타',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.other': '기타',
  'components.rightContent.receiptModal.title': '감사합니다',
  'components.rightContent.receiptModal.description': '보고서가 제출되었습니다.',
  'components.scribe.clickToStartRecording': '클릭하여 녹음 시작',
  'components.scribe.failedToGetAuthToken': '인증 토큰을 가져오지 못했습니다',
  'components.scribe.failedToStartRecording': '녹음을 시작하지 못했습니다',
  'components.searchPdfViewerWithHighlight.renderError': 'PDF를 렌더링하지 못했습니다',
  'components.themeToggle.themeSectionLabel': '테마',
  'components.themeToggle.themeTeal': '🌊 틸',
  'components.themeToggle.themeMaroon': '🍷 마룬',
  'components.themeToggle.modeSectionLabel': '모드',
  'components.themeToggle.lightMode': '라이트',
  'components.themeToggle.darkMode': '다크',
  'components.themeToggle.themeSettingsTooltip': '테마 설정',
  'components.whatsNewModal.title': '새로운 소식',
  'components.whatsNewModal.intro':
    '문서 검토 과정을 개선하기 위해 다양한 신규 기능을 도입했습니다:',
  'components.whatsNewModal.feature1.title': '필터링 개선: ',
  'components.whatsNewModal.feature1.description':
    '질문 목록을 더 빠르게 찾을 수 있도록 새로운 대상 및 작성자 필터가 추가되었습니다.',
  'components.whatsNewModal.feature2.title': '임시 질문: ',
  'components.whatsNewModal.feature2.description':
    '필요할 때 즉시 질문을 추가할 수 있는 더 유연한 방법입니다.',
  'components.whatsNewModal.feature3.title': 'UI 개선: ',
  'components.whatsNewModal.feature3.description':
    '{featureName}을(를) 더 쉽게 관리할 수 있도록 더 깔끔하고 직관적인 인터페이스를 제공합니다.',
  'components.whatsNewModal.upcomingFeatures.title': '출시 예정 기능',
  'components.whatsNewModal.upcomingFeatures.description':
    '협업 검토 및 고급 AI 분석 등 더 많은 업데이트를 기대해 주세요.',
  'components.user.uidLabel': 'UID',
  'components.user.idCopiedMessage': 'ID가 복사되었습니다!',
  'components.file.manager.fetchGroupError': '그룹을 가져오지 못했습니다: {message}',
  'components.file.manager.fetchFilesError': '파일을 가져오지 못했습니다: {message}',
  'components.file.manager.breadcrumbRoot': '루트',
  'components.file.manager.breadcrumbBackUpLevel': '상위 폴더로 이동',
  'components.file.manager.searchPlaceholder': '파일 또는 폴더 검색',
  'components.file.manager.uploadFileButton': '파일 업로드',
  'components.file.manager.createFolderButton': '폴더 생성',
  'components.file.manager.enterButton': '입력',
  'components.file.manager.deleteFolderButton': '폴더 삭제',
  'components.file.manager.deleteFileButton': '파일 삭제',
  'components.file.manager.uploadedByTime': '업로더: {username}, 업로드 시간: {createdAt}',
  'components.file.manager.folderNamePlaceholder': '폴더 이름',
  'components.file.filePreview.cannotPreview': '이 파일 형식은 미리 볼 수 없습니다',
  'components.file.documentSelector.sortNameAsc': '이름 (오름차순)',
  'components.file.documentSelector.sortNameDesc': '이름 (내림차순)',
  'components.file.documentSelector.sortNewestFirst': '최신순',
  'components.file.documentSelector.sortOldestFirst': '오래된순',
  'components.file.documentSelector.favourites': '즐겨찾기',
  'components.file.documentSelector.selectedCount': '선택됨 ({count}):',
  'components.file.documentSelector.selectAllFilesInFolder': '{folderName} 내 모든 파일 선택',
  'components.file.documentSelector.noFiles': '파일 없음',
  'components.file.documentSelector.folderAlt': '폴더',
  'components.file.documentSelector.fileAlt': '파일',
  'components.file.documentSelector.selectDocuments': '문서 선택',
  'components.file.documentSelector.selectOkText': '선택',
  'components.file.fileTree.uploadFailed': '{fileName} 업로드에 실패했습니다',
  'components.file.fileTree.clickOrDragToUpload': '클릭하거나 드래그하여 업로드',
  'components.file.fileTree.noFilesUploadedOrSelected': '업로드되었거나 선택된 파일이 없습니다.',
  'components.file.selectContext.cannotDeleteDefaultContext':
    '기본 컨텍스트는 삭제할 수 없습니다. 먼저 다른 컨텍스트를 기본값으로 설정해 주세요.',
  'components.file.selectContext.contextDeleted': '컨텍스트가 삭제되었습니다',
  'components.file.selectContext.deleteContextFailed': '컨텍스트를 삭제하지 못했습니다',
  'components.file.selectContext.enterContextNameWarning': '컨텍스트 이름을 입력해 주세요',
  'components.file.selectContext.contextCreated': '컨텍스트가 생성되었습니다',
  'components.file.selectContext.cannotUnsetDefaultContext':
    '기본 컨텍스트 설정을 해제할 수 없습니다. 먼저 다른 컨텍스트를 기본값으로 설정해 주세요.',
  'components.file.selectContext.contextUpdated': '컨텍스트가 업데이트되었습니다',
  'components.file.selectContext.createContextFailed': '컨텍스트를 생성하지 못했습니다',
  'components.file.selectContext.updateContextFailed': '컨텍스트를 업데이트하지 못했습니다',
  'components.file.selectContext.selectContextPresetPlaceholder': '컨텍스트 프리셋 선택',
  'components.file.selectContext.defaultLabel': '(기본값)',
  'components.file.selectContext.deleteContextConfirmTitle': '이 컨텍스트를 삭제하시겠습니까?',
  'components.file.selectContext.deleteContextConfirmDescription': '이 작업은 되돌릴 수 없습니다.',
  'components.file.selectContext.addNewContextTooltip': '새 컨텍스트 추가',
  'components.file.selectContext.modifyContextInfoTooltip': '컨텍스트 정보 수정',
  'components.file.selectContext.newContextLabel': '새 컨텍스트',
  'components.file.selectContext.editContextLabel': '컨텍스트 편집',
  'components.file.selectContext.contextTitlePlaceholder': '컨텍스트 제목',
  'components.file.selectContext.setAsDefaultLabel': '기본값으로 설정',
  'components.file.selectContext.contextSelectionTitle': '컨텍스트 선택',
  'components.file.selectContext.noContextSelected': '선택된 컨텍스트 없음',
  'components.appShell.logoutMenuItem': '로그아웃',
  'components.appShell.unauthorized.title': '이 페이지는 접근할 수 없습니다',
  'components.appShell.unauthorized.backHome': '홈으로 돌아가기',
  'components.appShell.promptLibrary.title': '프롬프트 라이브러리',
  'components.appShell.promptLibrary.noPromptsAvailable': '사용 가능한 프롬프트가 없습니다',
  'components.appShell.promptLibrary.copyTooltip': '프롬프트 내용 복사',
  'components.appShell.promptLibrary.untitledPrompt': '제목 없는 프롬프트',
  'components.appShell.promptLibrary.copiedMessage': '프롬프트가 클립보드에 복사되었습니다!',
  'components.appShell.clipboard.title': '클립보드',
  'components.appShell.clipboard.copiedMessage': '복사되었습니다!',
  'components.appShell.notFound.title': '이 페이지는 존재하지 않습니다',
  'components.gettingStartedTour.tourTask.chat.title': '채팅',
  'components.gettingStartedTour.tourTask.chat.duration': '~1분',
  'components.gettingStartedTour.tourTask.search.title': '검색',
  'components.gettingStartedTour.tourTask.search.duration': '~1분',
  'components.gettingStartedTour.tourTask.scribe.title': '스크라이브',
  'components.gettingStartedTour.tourTask.scribe.duration': '~2분',
  'components.gettingStartedTour.tourTask.review.title': '검토',
  'components.gettingStartedTour.tourTask.review.duration': '~3분',
  'components.gettingStartedTour.tourTask.playbook.title': 'Workstudio',
  'components.gettingStartedTour.tourTask.playbook.duration': '~2분',
  'components.matrixPolling.processingStoppedMessage': '처리가 중지되었습니다',
  'components.matrixPolling.stopProcessingFailedMessage': '처리 중지에 실패했습니다',
  'components.appShell.noResponseError': '응답 없음! 다시 시도해 주세요.',
  'components.appShell.requestError': '요청 오류, 다시 시도해 주세요.',
  'components.appShell.requestFailedError': '요청 실패!',
  'components.composerService.socketErrorPrefix': '오류: {message}',
  'components.composerService.sessionDisconnected': '다른 연결로 인해 Composer 세션이 끊어졌습니다',
  'components.fileViewerWithToken.retrieveFailedError': '파일을 가져오지 못했습니다',
  'components.languageSwitcher.switchLanguageTooltip': '언어 변경',
  'components.crossOrgBadge.sharedByLabel': '공유자: {orgName}',
  'components.crossOrgBadge.externalOrganization': '외부 조직',
  'components.file.sharePoint.fromComputer': '이 컴퓨터에서',
  'components.file.sharePoint.fromSharePoint': 'SharePoint / OneDrive에서',
  'components.file.sharePoint.orAddFromSharePoint': '또는 SharePoint / OneDrive에서 추가',
  'components.file.sharePoint.account': 'Microsoft 계정',
  'components.file.sharePoint.useDifferentAccount': '다른 계정 사용',
  'components.file.sharePoint.disconnect': '연결 해제',
  'components.file.sharePoint.disconnectConfirm':
    'A&GEL에서 Microsoft 계정 연결을 해제하시겠습니까?',
  'components.file.sharePoint.disconnected': 'Microsoft 계정 연결이 해제되었습니다.',
  'components.file.sharePoint.popupBlocked':
    'SharePoint에서 파일을 선택하려면 A&GEL의 팝업을 허용해 주세요.',
  'components.file.sharePoint.consentDeniedTitle': 'SharePoint 액세스가 승인되지 않음',
  'components.file.sharePoint.consentDenied':
    'SharePoint 액세스가 승인되지 않았습니다. 조직에서 IT 관리자 승인이 필요한 경우 IT 관리자에게 A&GEL 승인을 요청하세요.',
  'components.file.sharePoint.copyApprovalLink': 'IT 관리자용 승인 링크 복사',
  'components.file.sharePoint.approvalLinkCopied': '승인 링크가 복사되었습니다.',
  'components.file.sharePoint.connectFailed': 'Microsoft에 연결할 수 없습니다. 다시 시도해 주세요.',
  'components.file.sharePoint.reconnect': 'Microsoft 계정을 다시 연결해 주세요.',
  'components.file.sharePoint.unsupportedType':
    '{name}은(는) 여기에서 지원되지 않는 파일 형식입니다.',
  'components.file.sharePoint.tooLarge': '{name}이(가) 너무 큽니다(최대 {max}MB).',
  'components.file.sharePoint.rejected': '{name}을(를) 추가할 수 없습니다.',
  'components.file.sharePoint.downloadFailed':
    'SharePoint에서 {name}을(를) 가져올 수 없습니다. 다시 시도하거나 컴퓨터에서 업로드하세요.',
  'components.file.sharePoint.folderTooLarge':
    '이 폴더는 한 번에 가져오기에 너무 큽니다(최대 {max}개 파일). 더 작은 폴더를 선택하세요.',
  'components.file.sharePoint.chooserTitle': '파일 선택',
  'components.file.sharePoint.chooserMyFiles': '내 파일',
  'components.file.sharePoint.chooserShared': '공유됨',
  'components.file.sharePoint.chooserFollowedSites': '팔로우한 사이트',
  'components.file.sharePoint.chooserSearch': '사이트 검색',
  'components.file.sharePoint.chooserName': '이름',
  'components.file.sharePoint.chooserEmpty':
    '아직 팔로우한 사이트가 없습니다. 위에서 사이트를 검색하세요.',
  'components.file.sharePoint.chooserLocked':
    '팔로우하거나 검색한 사이트만 표시됩니다. 모든 사이트를 찾아보려면 IT 관리자에게 A&GEL 승인을 요청하세요.',
  'components.file.sharePoint.chooserLoading': '불러오는 중…',
  'components.file.sharePoint.chooserSelect': '선택',
  'components.file.sharePoint.chooserCancel': '취소',
};
